import { PasswordVerificationRequest } from './passwordVerificationRequest';

export class UpdateTwoFactorWebAuthnDeleteRequest extends PasswordVerificationRequest {
    id: number;
}
